module.exports = __webpack_public_path__ + "img/1.237acb2a.jpg";